/**
 *  ----------------------------------------------------------------
 *  Copyright © Mobiquity INC
 *  ----------------------------------------------------------------
 *  Author : Dhaval Marthak
 *  Filename : main.js
 *  Description:
 *  Main File Module Sample
 *  ----------------------------------------------------------------
 */

define( function (require, exports, module) {

    'use strict';

    module.name = 'module-mobile-utils';

    var base = require('base');
    var core = require('core');
    
    var deps = [
        core.name
    ];

    module.exports = base.createModule(module.name, deps)
        .factory(require('./mobile-alert-service'))
        .factory(require('./translate-service'))
        .factory(require('./common-service'))
        .service(require("./mobileTokenGenerator"));
});



//////////////////
// WEBPACK FOOTER
// ./scripts/main.js
// module id = 1
// module chunks = 0